<template>
  <div class="recent_leads">
    <app-loading-section :loading="loading">
      <app-record
        v-for="record in recentlyViewedLeads"
        :key="record.id"
        :record="record"
        class="recently_viewed_lead"
        tooltip-position="is-left"
      ></app-record>
    </app-loading-section>
  </div>
</template>

<script>
export default {
  name: "RecentLeadsModal",
  data() {
    return {
      loading: true,
      recentlyViewedLeads: [],
    };
  },
  created() {
    this.$api.records.getRecentlyViewedLeads().then(response => {
      this.recentlyViewedLeads = response.data;
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.recent_leads {
  position: relative;
  min-height: 80px;
}
</style>
